import { IPncpPurchaseContractDetailResponse } from "../../../model/base/response/pncp-purchase-contract-detail-response";

export enum ACTION_TYPES {
    LOAD_START = 'LOAD_START',
    LOAD_SUCCESS = 'LOAD_SUCCESS',
    LOAD_ERROR = 'LOAD_ERROR'
}

export interface IPncpPurchaseContractDetailState {
    contractDetail: IPncpPurchaseContractDetailResponse | null;
    loading: boolean;
    error: string | null;
}

export const initialState: IPncpPurchaseContractDetailState = {
    contractDetail: null,
    loading: true,
    error: null
};

export type Action =
    | { type: ACTION_TYPES.LOAD_START }
    | { type: ACTION_TYPES.LOAD_SUCCESS; payload: IPncpPurchaseContractDetailResponse }
    | { type: ACTION_TYPES.LOAD_ERROR; payload: string };

export const pncpPurchaseContractDetailReducer = (state: IPncpPurchaseContractDetailState, action: Action): IPncpPurchaseContractDetailState => {
    switch (action.type) {
        case ACTION_TYPES.LOAD_START:
            return { ...state, contractDetail: null, loading: true, error: null };
        case ACTION_TYPES.LOAD_SUCCESS:
            return { ...state, contractDetail: action.payload, loading: false };
        case ACTION_TYPES.LOAD_ERROR:
            return { ...state, loading: false, error: action.payload };
        default:
            throw new Error(`Unhandled action type`);
    }
};
